import React from "react";
import { motion } from "framer-motion";

const PRIVACY_TEXT = `PRIVACY POLICY

1. Introduction
Welcome to Study Partners. By installing or using our app, you agree to this Privacy Policy. This policy explains how we collect, use, store, and protect your information when you use our educational and collaborative learning platform.
 If you do not agree, you must discontinue use of the app and its services.

 2. Information We Collect
• Full Name, Mobile Number, City, Age, Gender, location
• Selected Exams.
• Device and usage data for performance optimization.
• Log and diagnostic information
• OTP verification via third-party SMS provider (authentication only).
• Messages are encrypted during transmission and securely stored using industry-standard encryption. Study Partners prioritizes user privacy and does not access private chats except when required for security, legal compliance, or investigation of reported misuse.

3. Chat Messages & Encryption
1. Encrypted Communication
Messages are encrypted during transmission and securely stored using industry-standard encryption. Study Partners prioritizes user privacy and does not access private chats except when required for security, legal compliance, or investigation of reported misuse.
2. No Access to Message Content
Messages are encrypted during transmission and securely stored using industry-standard encryption. Study Partners prioritizes user privacy and does not access private chats except when required for security, legal compliance, or investigation of reported misuse.
We use industry-standard safeguards to protect message data.
3. Server Storage & Transmission
Encrypted messages may be temporarily stored on secure servers strictly for the purpose of message routing, delivery, and synchronization.
All stored messages remain encrypted and are not accessible in readable form by Study Partners.
4. Disclosure & Legal Requests
Messages are encrypted during transmission and securely stored using industry-standard encryption. Study Partners prioritizes user privacy and does not access private chats except when required for security, legal compliance, or investigation of reported misuse.
We may provide non-content metadata (such as account information, if legally required) in compliance with applicable laws.
5. Security Responsibility
While we implement appropriate technical and organizational safeguards, users are responsible for maintaining the security of their devices and login credentials, as decrypted messages are accessible on their own devices.
 6. SMessages are encrypted during transmission and securely stored using industry-standard encryption. Study Partners prioritizes user privacy and does not access private chats except when required for security, legal compliance, or investigation of reported misuse.

No Access to Message Content
Messages are encrypted during transmission and securely stored using industry-standard encryption. Study Partners prioritizes user privacy and does not access private chats except when required for security, legal compliance, or investigation of reported misuse.

Encrypted Storage
Encrypted messages may be temporarily stored on secure servers solely for message transmission and delivery. These messages remain encrypted at all times.

No Selling or Sharing
We do not sell, trade, or share private chat content with any third party.

Users are responsible for securing their own devices, as decrypted messages are accessible only on their devices.
4. How We Use Your Information
• To create and manage user accounts
• To verify identity using OTP
• To connect users with suitable study partners
• To personalize learning recommendations
• To improve platform performance
• To provide customer support and important updates
• Authentication
• Matching study partners
• App functionality
• Security & misuse prevention

 5. SMS & OTP Verification
We use a third-party SMS gateway provider only to send One-Time Passwords (OTP) for secure login verification. We do not read, access, or store your personal SMS messages. Your mobile number is not used for marketing or promotional purposes.

 6. Data Sharing & Disclosure
Study Partners respects user privacy and does not sell, rent, or trade personal data or private communications.
1. No Sale of Data
We do not sell or monetize users’ personal information or private chat content to third parties.
2. Encrypted Chat Protection
Messages are encrypted during transmission and securely stored using industry-standard encryption. Study Partners prioritizes user privacy and does not access private chats except when required for security, legal compliance, or investigation of reported misuse.
3. Legal Compliance
We may disclose limited user information if required to do so by law, regulation, legal process, or governmental request.
Messages are encrypted during transmission and securely stored using industry-standard encryption. Study Partners prioritizes user privacy and does not access private chats except when required for security, legal compliance, or investigation of reported misuse.
4. Service Providers
We may share necessary information with trusted third-party service providers (such as hosting, analytics, or messaging infrastructure providers) strictly for operating and improving the service. These providers are contractually obligated to maintain confidentiality and data security.
5. Protection of Rights
We may disclose limited information when necessary to:
Enforce our Terms & Conditions
Prevent fraud, abuse, or illegal activity
Protect the safety and rights of users or the public

7. Third-Party Services
Study Partners uses carefully selected third-party service providers to operate and improve the app.
1. Firebase (Google LLC)
We use Firebase services for:
Cloud hosting & infrastructure
Authentication
Crash reporting
Performance monitoring
Secure data storage
Firebase may process device information, app usage data, and technical diagnostics. Data processed through Firebase may be transferred and stored on servers located outside the user’s jurisdiction, subject to appropriate safeguards.
Users may review Google’s Privacy Policy for further details.
2. DLT SMS Provider (OTP Verification)
We use a registered Distributed Ledger Technology (DLT) compliant SMS provider to send One-Time Passwords (OTP) for account authentication.
Phone numbers are used solely for verification and security purposes.
OTP delivery is processed through authorized telecom operators.
We do not send promotional SMS without user consent.
3. QR Code for Voluntary Support
Study Partners may display a QR code for users who voluntarily choose to support the platform.
Contributions are entirely optional.
Payments are processed directly through third-party UPI or payment providers.
Study Partners does not collect or store bank account numbers, UPI PINs, card details, or financial credentials.
Study Partners does not function as a financial institution or payment intermediary.

 8. International Data Transfers
Certain third-party service providers (including Firebase) may process or store data on servers located outside India. By using the app, users acknowledge and consent to such data transfers, subject to reasonable security safeguards.

 9. Limitation of Liability – Third-Party Services
While Study Partners selects service providers with reasonable care, we are not responsible for:
Security practices of third-party platforms
Service outages or interruptions
Data handling practices governed by third-party privacy policies
Users are encouraged to review the privacy policies of such providers.
10. Data Protection Commitment
We implement reasonable technical and organizational safeguards to protect user information against unauthorized access, disclosure, alteration, or destruction.
However, no digital platform can guarantee absolute security. Users acknowledge and accept inherent risks associated with internet-based services.

11. Data Security
Study Partners is committed to protecting user information through reasonable technical, administrative, and organizational security measures designed to prevent unauthorized access, disclosure, alteration, misuse, or destruction of data.
1. Security Safeguards
We implement appropriate security measures including, but not limited to:
Encryption during transmission and secure encrypted storage for private chat communications
Encrypted data transmission using secure protocols (e.g., HTTPS/TLS)
Secure server infrastructure and controlled access mechanisms
Authentication and access control procedures
Regular monitoring for security vulnerabilities
2. Restricted Access
Access to user data is strictly limited to authorized personnel and service providers who require such access for legitimate operational purposes and are bound by confidentiality obligations.
Messages are encrypted during transmission and securely stored using industry-standard encryption. Study Partners prioritizes user privacy and does not access private chats except when required for security, legal compliance, or investigation of reported misuse.
3. Data Retention & Storage Security
User data is stored on secure infrastructure provided by trusted service providers (including Firebase). We retain personal data only for as long as necessary to fulfill legitimate business purposes or comply with legal obligations.
4. Incident Response
In the event of a data security incident, we will take reasonable steps to investigate, mitigate, and comply with applicable legal requirements.
5. No Absolute Guarantee
While we strive to use commercially reasonable safeguards, no method of electronic storage or transmission over the internet is completely secure. Therefore, Study Partners cannot guarantee absolute security of data.
Users are responsible for safeguarding their account credentials and device access.

12. Cookies & Analytics
Study Partners may use cookies, SDKs, and similar tracking technologies to operate, analyze, and improve the app and related services.
1. Cookies & Similar Technologies
If Study Partners operates a website, cookies and similar technologies may be used to:
Maintain secure sessions
Remember user preferences
Improve functionality and performance
Analyze traffic patterns
Users may manage or disable cookies through browser settings. Disabling cookies may affect certain website features.
2. Analytics & Diagnostic Services
We use trusted third-party analytics services, including Firebase Analytics and related diagnostic tools, to collect limited technical and usage information such as:
Device model and operating system
App version
Session duration and interaction data
Crash reports and performance metrics
Anonymous identifiers
This data is used strictly for:
Improving app stability
Fixing technical issues
Enhancing user experience
Monitoring service performance
Analytics data is typically aggregated or pseudonymized and does not include private chat content. Messages are encrypted during transmission and securely stored using industry-standard encryption.
3. No Behavioral Advertising
Study Partners does not use third-party advertising networks for behavioral tracking or cross-app advertising unless explicitly disclosed.
We do not sell analytics data to advertisers.
4. Third-Party Data Processing
Analytics data may be processed on servers located outside the user’s jurisdiction in accordance with the privacy policies of the respective service providers.
Users are encouraged to review the privacy policies of third-party analytics providers for further details.
5. Limitation of Tracking Liability
While we use reputable service providers, Study Partners is not responsible for independent data practices of third-party analytics platforms governed by their own privacy policies.

 13. COMMUNITY GUIDELINES
Use the App only for study
Be respectful and professional
No harassment or abuse
No fake information or leaks
No dating or personal misuse
Violation = Immediate action.

14. SENSITIVE INFORMATION
Kindly do not send us or disclose any sensitive personal information for example information relating to your racial or ethnic origin, political opinions, personal details, religion or other beliefs, health etc. on or through the site, app or otherwise to us.

15. Authorized & Legal Statement
This Privacy Policy constitutes the official and legally binding statement of Study Partners regarding the collection, processing, storage, and protection of user information in connection with the Study Partners mobile application and related services (“Services”).
By accessing, registering, or using the Services, users acknowledge that they have read, understood, and agreed to the terms outlined in this Privacy Policy. If a user does not agree with this Privacy Policy, they must discontinue use of the Services immediately.
This Privacy Policy shall be governed by and construed in accordance with the laws of India, including applicable provisions of the Information Technology Act, 2000, and related rules, without regard to conflict of law principles.
To the maximum extent permitted by applicable law:
Study Partners shall not be liable for indirect, incidental, consequential, or special damages arising from the use of the Services.
Study Partners shall not be responsible for actions, omissions, or data handling practices of independent third-party service providers governed by their own privacy policies.
Users acknowledge that no system of transmission or storage over the internet can be guaranteed to be 100% secure.
Study Partners reserves the right to modify, amend, or update this Privacy Policy at its sole discretion. Updated versions will be posted within the application or on the official platform, and continued use of the Services after such updates constitutes acceptance of the revised Policy.
If any provision of this Privacy Policy is found to be invalid or unenforceable under applicable law, the remaining provisions shall continue in full force and effect.

 16. Children’s Privacy
Study Partners is intended for general educational use and is not specifically directed toward children under the age of 13.
1. Minimum Age Requirement
Users must be at least 13 years of age to create an account and use the Services.
By registering or using the Services, users represent and warrant that they meet this minimum age requirement.
If a user is under 18 years of age, they must use the Services only with the supervision and consent of a parent or legal guardian.
2. No Knowing Collection from Children Under 13
Study Partners does not knowingly collect, solicit, or process personal information from children under 13 years of age without verified parental consent.
If we become aware that personal information has been collected from a child under 13 in violation of applicable law, we will:
Take reasonable steps to investigate the matter
Delete such information promptly
Suspend or terminate the associated account, where appropriate
3. Parental Rights
Parents or legal guardians who believe that a child has provided personal information without consent may contact us to request:
Review of the information
Correction of inaccurate information
Deletion of such information
We will take reasonable steps to verify the identity of the requesting party before processing such requests.
4. Compliance with Applicable Laws
This section is intended to comply with applicable child data protection requirements, including international standards relating to children’s online privacy, where applicable.

 17. User Rights & Data Control
Study Partners respects users’ rights regarding their personal information.
Subject to applicable laws, users may have the right to:
Access the personal information associated with their account
Request correction or updating of inaccurate information
Request deletion of their account and personal data
Withdraw consent, where processing is based on consent
Request clarification regarding how their data is processed
Users may exercise these rights by:
Using the in-app “Delete Account” feature, or
Contacting our support team through the official contact details provided in this Privacy Policy.
We may take reasonable steps to verify the identity of the requesting user before processing data-related requests.
Certain information may be retained where required for legal compliance, fraud prevention, dispute resolution, or legitimate business purposes.

18. Data Retention & Account Deletion
We retain personal data only as long as necessary.
Users may delete their account using the in-app “Delete Account” feature.
Upon deletion:
Account data is deleted or anonymized within a reasonable timeframe.
Access is permanently removed.
Certain data may be retained for legal or fraud prevention purposes.
Deleting an account does not automatically remove messages stored on other users’ devices.

19. Compliance with Google Play Policies
Study Partners is designed and operated in compliance with applicable Google Play Developer Program Policies, including User Data, Privacy, and SMS/Call Log policies.
We are committed to:
Collecting and processing user data in a transparent and lawful manner
Limiting data collection to what is necessary for app functionality
Using SMS functionality solely for user authentication and account verification purposes (e.g., OTP)
Avoiding deceptive, misleading, or harmful practices
The app does not knowingly facilitate gambling, illegal activities, or malicious behavior.
Study Partners reserves the right to modify features and policies as required to maintain compliance with Google Play policies and applicable laws.

 20. Changes to This Privacy Policy
Study Partners reserves the right to update, amend, or modify this Privacy Policy at any time, at its sole discretion. Any changes will become effective immediately upon being published within the Study Partners application or on its official platform, unless otherwise stated.
Users are encouraged to review this Privacy Policy periodically to remain informed about how we collect, use, and protect their information.
Your continued access to or use of the Study Partners app after any updates to this Privacy Policy constitutes your acknowledgment of the revised policy. If you do not agree with the updated Privacy Policy, you must discontinue use of the app and its services.

 21. CONTACT US
For any questions or concerns regarding this Privacy Policy, please contact us at:
Legal Department
Study Partners
Email: medicalstudent204@gmail.com

 22. DISCLAIMER
Study Partner is only a technology platform.
We do not provide teaching, coaching, or academic guarantees.
All study discussions are peer-to-peer.
Study Partners is a student discussion platform only.
We do not provide educational services or guarantee exam results.

 23. Consent & Declaration
By clicking “I AGREE & CONTINUE”,
I voluntarily, knowingly, and legally confirm the following:
1. I am a student of Class 9 or above.
2. If I am below 18 years, I confirm I have valid parent/guardian consent.
3. I understand Study Partners is only a technology platform, not a school, teacher, tutor, or coaching institute.
4. I understand the app does NOT provide education, teaching, guidance, counseling, or exam guarantees.
5. I understand all chats and discussions are peer-to-peer, user-generated content only.
6. I accept that study advice from users may be incorrect, incomplete, or harmful.
7. I agree that all academic decisions and outcomes are entirely my responsibility.
8. I understand the app does not verify users, exams, study content, or accuracy of information.
9. I acknowledge the app works only as an intermediary under Indian IT laws.
10. I agree that Study Partners and its owner do not control or endorse any user content.
11. I consent to the use of my mobile number for OTP login.
12. I consent to the use of my approximate location for nearby matching.
13. I consent to share my age, gender, and up to 5 exam names for matching purposes.
14. I understand matching happens only by user request and mutual acceptance.
15. I accept that the app does not guarantee safety, compatibility, or behavior of any user.
16. I agree not to misuse the app for abuse, dating, fraud, illegal activity, or harassment.
17. I understand my account may be suspended or permanently deleted at any time without notice.
18. I accept that any misuse may be reported to authorities if required by law.
19. I agree that all legal responsibility for my actions lies with me, not the app owner.
20. I agree that the owner's legal liability is limited and reasonable. To the maximum extent permitted under applicable law, Study Partners' liability shall be limited and reasonable. We shall not be liable for indirect, incidental, consequential, user-generated, or interaction-related damages arising from the use of the platform.
21. I waive all claims against the app and its owner arising from my use of the platform.
22. I confirm that I am Class 9 or above, have parental consent if under 18, and agree to the Terms & Privacy Policy.
23. I allow the app to use my approximate location for matching study partners.
24. I understand Study Partners acts as an intermediary platform and does not control or endorse user-generated content, and users are solely responsible for their communications and interactions on the platform.
25. I confirm that I have read, understood, and voluntarily agreed to all Terms, Privacy Policy, Disclaimers, and Community Guidelines.

I agree to Study Partners Terms & Conditions and Privacy Policy. I understand that Study Partners acts as an intermediary platform and does not control or endorse user-generated content, and users are solely responsible for their communications and interactions on the platform.`;

const PrivacyPolicy = () => {
  return (
    <section className="relative bg-[#C8F1F9] min-h-screen px-6 py-20 overflow-hidden">
      <div className="absolute top-24 left-10 w-72 h-72 bg-[#3498db]/20 rounded-full blur-3xl" />
      <div className="absolute bottom-20 right-10 w-72 h-72 bg-pink-300/20 rounded-full blur-3xl" />

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="relative max-w-4xl mx-auto bg-white/80 backdrop-blur-2xl rounded-3xl shadow-[0_30px_90px_rgba(0,0,0,0.15)] px-6 md:px-12 py-12 text-gray-800"
      >
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-4xl md:text-5xl font-extrabold text-center text-[#3498db] mb-12"
        >
          Privacy Policy
        </motion.h1>

        <pre className="whitespace-pre-wrap break-words text-sm md:text-base leading-relaxed font-sans">
          {PRIVACY_TEXT}
        </pre>
      </motion.div>
    </section>
  );
};

export default PrivacyPolicy;
